/**
 * Every route becomes a chunk, loaded only when used.
 * Reduces size of initial App load.
 */
const routes = [
  {
    name: 'login',
    path: '/:tenantCode?/login',
    component: () => import('views/login'),
    meta: {
      title: 'Connexion',
      layout: 'LoginLayout'
    }
  },
  {
    name: 'reset',
    path: '/:tenantCode?/reset',
    component: () => import('views/login'),
    meta: {
      title: 'Mot de passe oublié',
      layout: 'LoginLayout'
    }
  },
  {
    name: 'device',
    path: '/:tenantCode?/device',
    component: () => import('views/device'),
    meta: {
      title: 'Mes supports',
      needAuth: true
    }
  },
  {
    name: 'reports',
    path: '/:tenantCode?/reports',
    component: () => import('views/reports'),
    meta: {
      title: 'Mes déclarations',
      needAuth: true
    }
  },
  {
    name: 'reports/new',
    path: '/:tenantCode?/reports/new',
    component: () => import('views/reports/reporting'),
    meta: {
      title: 'Nouvelle déclaration',
      needAuth: true
    },
    props: true
  },
  {
    name: 'reports/update',
    path: '/:tenantCode?/reports/update',
    component: () => import('views/reports/reporting'),
    meta: {
      title: "Modification d'une déclaration",
      needAuth: true
    },
    props: true
  },
  {
    name: 'reports/recap',
    path: '/:tenantCode?/reports/recap',
    component: () => import('views/reports/recap'),
    meta: {
      title: 'Récapitulatif de la déclaration',
      needAuth: true
    },
    props: true
  },
  {
    name: 'reports/end',
    path: '/:tenantCode?/reports/end',
    component: () => import('views/reports/end'),
    meta: {
      title: 'Déclaration envoyée',
      needAuth: true
    },
    props: true
  },
  {
    name: 'report-history',
    path: '/:tenantCode?/report-history',
    component: () => import('views/report-history'),
    meta: {
      title: 'Mes déclarations',
      needAuth: true
    }
  },
  {
    name: 'user/infos',
    path: '/:tenantCode?/user/infos',
    component: () => import('views/user/infos'),
    meta: {
      title: 'Mes informations',
      needAuth: true
    }
  },
  {
    name: 'user/cases',
    path: '/:tenantCode?/user/cases',
    component: () => import('views/user/cases'),
    meta: {
      title: 'Mes dossiers',
      needAuth: true
    }
  },
  {
    name: 'user/account',
    path: '/:tenantCode?/user/account',
    component: () => import('views/user/account'),
    meta: {
      title: 'Mon compte',
      needAuth: true
    }
  },
  {
    name: 'documents',
    path: '/:tenantCode?/documents',
    component: () => import('views/documents'),
    meta: {
      title: 'Mes documents',
      needAuth: true
    }
  },
  {
    name: 'home',
    path: '/:tenantCode?',
    component: () => import('views/home'),
    meta: {
      title: 'Portail TLPE',
      layout: 'HomeLayout'
    }
  },
  {
    path: '*',
    redirect: '/'
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/router/routes.js